import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "position-absolute bg-white z-2 w-100 main-menu overflow-hidden" }
const _hoisted_2 = { class: "container position-relative d-flex flex-column h-100" }
const _hoisted_3 = { class: "row h-100" }
const _hoisted_4 = {
  key: 0,
  class: "col order-lg-last overflow-scroll overscroll-contain no-scrollbar h-100"
}
const _hoisted_5 = {
  key: 0,
  class: "w-100 h-100 text-center"
}
const _hoisted_6 = { class: "col-12 col-lg-3 overflow-scroll overscroll-contain no-scrollbar h-100 border-end g-0 me-2" }
const _hoisted_7 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon")
  const _component_results = _resolveComponent("results")
  const _component_filters = _resolveComponent("filters")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "btn-close position-absolute top-0 end-0 mx-3 my-4 p-2 rounded-circle border bg-white d-none d-lg-block",
        type: "button",
        onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.close && _ctx.close(...args)))
      }),
      (!_ctx.is_main)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: "d-md-none clickable h5 dropdown-item d-block mt-1",
            onClick: _cache[1] || (_cache[1] = _withModifiers($event => ($options.open_link()), ["stop","prevent"]))
          }, [
            _createVNode(_component_icon, { name: "ARROW_LEFT" }),
            _createTextVNode(" " + _toDisplayString(_ctx.translations.actions.SHOW_ALL), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.is_main)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (!_ctx.main_descendants && !_ctx.is_main)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("div", { class: "spinner-border muted m-5 p-5" }, null, -1 /* CACHED */)
                  ]))]))
                : _createCommentVNode("v-if", true),
              (_ctx.main_descendants)
                ? (_openBlock(), _createBlock(_component_results, {
                    key: 1,
                    pages: _ctx.main_descendants
                  }, null, 8 /* PROPS */, ["pages"]))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.megamenu_content)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass({ 'd-none d-lg-flex': _ctx.main_descendants })
              }, [
                _createVNode(_component_filters, {
                  action: $options.open_link,
                  class: "mt-4 w-100",
                  filters: _ctx.megamenu_filters,
                  selected: _ctx.url
                }, null, 8 /* PROPS */, ["action", "filters", "selected"])
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true),
          (_ctx.html_content)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "w-100 d-flex flex-column d-lg-none mb-4 ms-3",
                innerHTML: _ctx.html_content
              }, null, 8 /* PROPS */, _hoisted_7))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ])
  ]))
}